// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1_xvt","list":"BalanceDue_list__Wb-bD","listRow":"BalanceDue_listRow__1b-2W","total":"BalanceDue_total__2usTg"};